module.exports = __webpack_public_path__ + "static/media/account-feature-start.0d21a218.png";